/*
 * Autoplay compartilhado dos carrosséis hogrid (reviews e recomendações).
 * Pausa em hover, toque, foco de teclado (WCAG 2.2.2) e aba oculta;
 * as setas de navegação funcionam como mecanismo de parada definitiva.
 * Limpa listeners globais quando a seção é recarregada no theme editor.
 */
window.hogridSetupAutoplay = function (options) {
  var root = options.root;
  var carousel = options.carousel;
  var move = options.move;
  var interval = options.interval || 0;
  if (!root || !carousel || typeof move !== 'function' || interval <= 0) return null;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;

  var timer = null;
  var focused = false;
  var touching = false;
  var stoppedByUser = false;

  function shouldRun() {
    return !document.hidden && !focused && !touching && !stoppedByUser;
  }

  function stopTimer() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  function maybeStart() {
    stopTimer();
    if (shouldRun()) {
      timer = window.setInterval(function () {
        move(1);
      }, interval);
    }
  }

  // Sem pausa por hover: a seção ocupa a tela e o mouse parado sobre ela
  // deixava o carrossel eternamente pausado no desktop. Os mecanismos de
  // parada (WCAG 2.2.2) são as setas (stop definitivo), o foco de teclado,
  // o toque e prefers-reduced-motion.
  carousel.addEventListener('touchstart', function () {
    touching = true;
    stopTimer();
  }, { passive: true });
  carousel.addEventListener('touchend', function () {
    touching = false;
    maybeStart();
  }, { passive: true });
  root.addEventListener('focusin', function () {
    focused = true;
    stopTimer();
  });
  root.addEventListener('focusout', function (event) {
    if (!root.contains(event.relatedTarget)) {
      focused = false;
      maybeStart();
    }
  });

  var onVisibility = function () {
    if (document.hidden) stopTimer();
    else maybeStart();
  };
  document.addEventListener('visibilitychange', onVisibility);

  var api = {
    // Interação manual (setas): para o autoplay em definitivo (mecanismo de "stop" acessível)
    stop: function () {
      stoppedByUser = true;
      stopTimer();
    },
    destroy: function () {
      stopTimer();
      document.removeEventListener('visibilitychange', onVisibility);
    }
  };

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target && event.target.contains && event.target.contains(root)) {
      api.destroy();
    }
  });

  maybeStart();
  return api;
};
